import { useMemo } from 'react';
import qrcode from 'qrcode-generator';

// ─── QR code local ───────────────────────────────────────────
// Rendu SVG dans le navigateur : l'URI `otpauth://` contient le SECRET du 2FA,
// qui ne doit jamais partir vers un service tiers de génération d'images.
export function QrCode({ value, size = 200 }) {
  const svg = useMemo(() => {
    const qr = qrcode(0, 'M');
    qr.addData(value);
    qr.make();
    return qr.createSvgTag({ cellSize: 4, margin: 4, scalable: true });
  }, [value]);
  return (
    <div
      className="rounded-lg inline-block"
      style={{ background: 'white', width: size, height: size, padding: 8, boxSizing: 'content-box' }}
      role="img"
      aria-label="QR code d'enregistrement 2FA"
      // SVG produit localement par la bibliothèque à partir de `value`, aucune entrée HTML.
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
